import './AccordionText.css';
import { useRef, useState } from 'react';
import React from 'react';

export default function AccordionText({ title, text, iconSize = '2rem' }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const toggleAccordion = () => setIsOpen(open => !open);

  const withLineBreaks = (str) =>
    str.split('\n').map((line, i, arr) => (
      <React.Fragment key={i}>
        {line}
        {i < arr.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <div className="accordion-text-container">
      <button className="accordion-title" onClick={toggleAccordion}>
        <span>{title}</span>
        <span className="accordion-symbol" style={{ fontSize: iconSize }}>{isOpen ? '–' : '+'}</span>
      </button>
      
      <div
        className={`accordion-content${isOpen ? ' open' : ''}`}
        ref={contentRef}
        style={{
          maxHeight: isOpen
            ? `${contentRef.current?.scrollHeight}px`
            : '0px',
          overflow: 'hidden',
        }}
        aria-hidden={!isOpen}
      >
        {Array.isArray(text)
          ? text.map((paragraph, idx) => (
              <div style={{ marginBottom: '20px' }} key={idx}>
                {typeof paragraph === 'string' ? withLineBreaks(paragraph) : paragraph}
              </div>
            ))
          : (
            <div style={{ marginBottom: '20px' }}>
              {typeof text === 'string' ? withLineBreaks(text) : text}
            </div>
          )
        }
      </div>
    </div>
  );
}